import { useFetchCashBalance } from 'views/shared/hooks/useFetchCashBalance';

/**
 * Whether the signed-in account is a prospect - someone exploring the product
 * with demonstration holdings rather than a client with real stock.
 *
 * Prospect holdings carry real wines but asset units that are not backed by
 * physical bottles, so buying and selling are closed to them. Use this to hide
 * those actions; it is presentation only, and the API refuses the calls whether
 * or not the buttons are drawn.
 *
 * Reads the cash-balance query the app already loads on start-up, so it costs no
 * extra request. Defaults to false until that resolves, which keeps the normal
 * client experience unchanged while loading.
 */
export const useIsProspect = (): boolean => {
  const { data } = useFetchCashBalance();
  return data?.isProspect === true;
};
